import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

interface IState {
  RegistrationReceivedList: {
    status: StateStatus | null;
    data: any;
  };
  viewRegistrationReceived: {
    status: StateStatus | null;
    data: any;
  };
  FixedEstablishmentReceivedList: {
    status: StateStatus | null;
    data: any;
  };
  memberStateExcludeCyprusList: any;
  unreadNotificationCount: {
    status: StateStatus | null;
    data: number;
  };
}

const initialState: IState = {
  RegistrationReceivedList: {
    status: null,
    data: null,
  },
  viewRegistrationReceived: {
    status: null,
    data: null,
  },
  FixedEstablishmentReceivedList: {
    status: null,
    data: null,
  },
  memberStateExcludeCyprusList: {
    status: null,
    data: null,
  },
  unreadNotificationCount: {
    status: null,
    data: 0,
  },
};

const RegistrationReceivedReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_REGISTRATION_RECEIVED_LIST:
      return {
        ...state,
        RegistrationReceivedList: {
          ...state.RegistrationReceivedList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.RegistrationReceivedList.data
              : action.data,
        },
      };
    case Types.SET_REGISTRATION_RECEIVED_DETAIL:
      return {
        ...state,
        viewRegistrationReceived: {
          ...state.viewRegistrationReceived,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.viewRegistrationReceived.data
              : action.data,
        },
      };
    case Types.SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID:
      return {
        ...state,
        FixedEstablishmentReceivedList: {
          ...state.FixedEstablishmentReceivedList,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.FixedEstablishmentReceivedList.data
              : action.data,
        },
      };
    case Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS:
      return {
        ...state,
        memberStateExcludeCyprusList: {
          status: action.status,
          data: action.data,
        },
      };
    case Types.SET_UNREAD_NOTIFICATION_COUNT:
      return {
        ...state,
        unreadNotificationCount: {
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.unreadNotificationCount.data
              : action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default RegistrationReceivedReducer;
